module.exports = "/assets/data/656224618fd50e16abfe47c8a3cbd2df-MK4.data.json";